export const name = "LEAST";
export const summary = `Gets the least value among \`X1,...,XN\`.`;
export const reference = `
## LEAST

Gets the least value among \`X1,...,XN\`.

\`\`\`
LEAST(X1,...,XN)
\`\`\`

### Description

Returns the least value among \`X1,...,XN\`. If any argument is \`NULL\`, returns\`NULL\`. Otherwise, in the case of floating-point arguments, if any argument is\`NaN\`, returns \`NaN\`. In all other cases, returns the value among \`X1,...,XN\`that has the least value according to the ordering used by the \`ORDER BY\`clause. The arguments \`X1, ..., XN\` must be coercible to a common supertype, and the supertype must support ordering.

| X1,...,XN | LEAST(X1,...,XN) |
| --- | --- |
| 3,5,1 | 1 |

This function supports specifying collation.


### Return Data Types

Data type of the input values.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
